function setHash(newHash) {
    if (typeof newHash === "string") {
        window.location.hash = newHash.startsWith("#") ? newHash : `#${newHash}`;
    } else {
        console.error("Invalid hash value. Must be a string.");
    }
}

export default setHash;


const removeHash = () => {
    // Check if the URL has a hash
    if (window.location.hash) {
        // Use history.replaceState to update the URL without the hash
        window.history.replaceState(
            null,
            '',
            window.location.href.split('#')[0]
        );
    }
};
export { removeHash }